<div class="mb-2 inline-block">
  <p-tabs [(value)]="activeTabIndex">
    <p-tablist>
      <p-tab [value]="0">GHG</p-tab>
      <p-tab [value]="1">ISO 14064-1</p-tab>
    </p-tablist>
  </p-tabs>
</div>

<div class="table-container">
  @if (displayData.length > 0) {
    <div>
      <p-table
        [value]="displayData"
        [scrollable]="true"
        scrollHeight="600px"
        class="p-datatable-sm"
        [tableStyle]="{'min-width': '70rem'}">
        <ng-template #header>
          <tr>
            <th>Fuentes de emisión</th>
            @for (col of monthsColumns; track col.field) {
              <th class="text-right">{{ col.header }}</th>
            }
            <th class="text-right">Total</th>
          </tr>
        </ng-template>
        <ng-template #body let-row>
          @if (isGroupHeader(row)) {
            <tr class="bg-gray-200 font-semibold">
              <td [attr.colspan]="monthsColumns.length + 2" class="p-3">
                {{ row.groupKey }}
              </td>
            </tr>
          }
          @else if (isTotal(row)) {
            <tr class="font-bold bg-gray-100">
              <td>Total {{ row.groupName }}</td>
              <td class="text-right">{{ row.totals.jan | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.feb | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.mar | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.apr | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.may | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.jun | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.jul | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.aug | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.sep | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.oct | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.nov | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.dec | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.total | number:'1.2-2' }}</td>
            </tr>
          }
          @else if (isGrandTotal(row)) {
            <tr class="font-bold bg-blue-100">
              <td>Total</td>
              <td class="text-right">{{ row.totals.jan | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.feb | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.mar | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.apr | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.may | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.jun | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.jul | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.aug | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.sep | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.oct | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.nov | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.dec | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.totals.total | number:'1.2-2' }}</td>
            </tr>
          }
          @else {
            <tr>
              <td>{{ row.sourceName }}</td>
              <td class="text-right">{{ row.jan | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.feb | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.mar | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.apr | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.may | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.jun | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.jul | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.aug | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.sep | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.oct | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.nov | number:'1.2-2' }}</td>
              <td class="text-right">{{ row.dec | number:'1.2-2' }}</td>
              <td class="text-right font-semibold">{{ row.sourceTotal | number:'1.2-2' }}</td>
            </tr>
          }
        </ng-template>
      </p-table>
    </div>
  } @else {
    <div class="text-center py-8 text-gray-500">
      No hay resultados para mostrar
    </div>
  }
</div>
